import React from 'react';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc, Reception } from 'api';
import {Toastr} from 'modules/toastr';
import {msg} from 'constants/message';
import {Input} from 'components/tt-forms/common';
import {MasterLayout} from 'layout';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import {LimitFileSize} from 'constants/config';
import copy from 'copy-to-clipboard';

class CustomOption extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      progress: 0
    };
  }
  uploadFile(e) {
    if (e.target.files[0]) {
      let fileSize = e.target.files[0].size;
      if (fileSize > LimitFileSize*1024*1024) {
        Toastr(msg.fileSizeErr, 'warning');
      } else if (fileSize == 0) {
        Toastr(msg.fileSizeNull, 'warning');
      } else {
        let params = {field: 'file', file: e.target.files[0]};

        params.progress = (progress) => {
          let progressBar = Math.round( (progress.loaded * 100) / progress.total );

          this.setState({progress: progressBar});
        }

        Reception.actions.postFileUploadHDSD.request('', params).then(res => {
          this.setState({progress: 0});
          copy(res.data);
          Toastr('Đường dẫn đã được copy vào clipboard', 'success');
        });
      }
    }
  }

  render() {
    return (
      <div className="wrap-link-todo link-attach" style={{paddingTop: '7px'}}>
        <div className="upload_file_content">
          <input type="file" name='uploadFile' className="upload" ref='btnUpload' onChange={this.uploadFile.bind(this)}/>
          <span htmlFor="file">Tải lên tập tin</span>
        </div>
        {
          this.state.progress > 0 &&
          <div className="pt-progress-bar progress-upload pt-intent-primary">
            <div className="pt-progress-meter" style={{width: `${this.state.progress}%`}} />
          </div>
        }
      </div>
    );
  }
}


class HuongDanSuDung extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isSubmit: false,
      data: [],
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryId: 0,
      buttonLoading: false,
      categoryDesc: EditorState.createEmpty(),
    };
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
  }
  componentDidMount() {
    this.getListData();
  }
  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }
  getListData() {
    Danhmuc.actions.getHuongDanSuDung.request().then(res => {
     if (res.data._embedded) {
      const contentBlock = htmlToDraft(res.data._embedded.huongDanSuDungs[0].noiDung);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
        this.setState({
          categoryId: res.data._embedded.huongDanSuDungs[0].huongDanSuDungId,
          categoryName: res.data._embedded.huongDanSuDungs[0].ten,
          categoryDesc: editorState,
          addType: 2
        });
      }
    });
  }
  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }
  componentWillUnmount() {
    this.props.validators['danhMuc'] = [];
  }
  createCategory() {
    if (this.checkValidate()) {
      let params = {
        ten: this.state.categoryName.trim(),
        noiDung: draftToHtml(convertToRaw(this.state.categoryDesc.getCurrentContent()))
      };

      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        this.props.danhMuc.updateHuongDanSuDung({id: this.state.categoryId},params).then(res => {
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        this.props.danhMuc.postHuongDanSuDung('',params).then(res => {
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }
  onEditorStateChange(categoryDesc) {
    this.setState({ categoryDesc });
  }
  openAddNewCategory() {
    this.setState({isSubmit: false});
    this.setState({
      addType:0,
      categoryName: '',
      categoryDesc: '',
      isValid: true
    });
  }
  uploadImageCallBack(file) {
    return new Promise(
      (resolve, reject) => {
        let params = {
          field: 'file', file: file
        };
        params.progress = (progress) => {
        }
        Reception.actions.postFileUpload.request('', params).then(res => {
          if (res.data) {
            let output = {
              data: {
                link: res.data
              }
            }
            resolve(output);
          }
        }).catch(e => {
          reject(e);
        });
      }
    );
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Hướng dẫn sử dụng</p>
            </div>
          </div>
          <div className="bottom-content">
            <section className="page-wrapper">
              <Input className="" label="Tên" value={this.state.categoryName} require={true} maxLength={999} onChange={this.onChange.bind(this, 'categoryName')} bindValidator={this} channel="danhMuc"/>
              <Editor
                editorState={this.state.categoryDesc}
                wrapperClassName="wrapper-editor mb18"
                editorClassName="container-editor"
                editorStyle={{
                    minHeight: 350,
                    border: "1px solid #d8d8d8",
                    padding: 5,
                    borderRadius: 2,
                    height: "auto",
                }}
                toolbar={{
                  options: ['blockType', 'inline', 'list', 'link', 'image', 'colorPicker', 'textAlign'],
                  blockType: {
                    inDropdown: true,
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code']
                  },
                  inline: {
                    inDropdown: false,
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                    options: ['bold', 'italic', 'underline'],
                  },
                  list: {
                    inDropdown: false,
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                    options: ['unordered', 'ordered', 'indent', 'outdent']
                  },
                  link: {
                    inDropdown: false,
                    className: undefined,
                    component: undefined,
                    popupClassName: undefined,
                    dropdownClassName: undefined,
                    showOpenOptionOnHover: true,
                    defaultTargetOption: '_self',
                    options: ['link', 'unlink']
                  },
                  image: {
                    className: undefined,
                    component: undefined,
                    popupClassName: undefined,
                    urlEnabled: true,
                    uploadEnabled: true,
                    alignmentEnabled: true,
                    uploadCallback: this.uploadImageCallBack,
                    previewImage: true,
                    inputAccept: 'image/*',
                    alt: { present: false, mandatory: false },
                    defaultSize: {
                      height: 'auto',
                      width: 'auto',
                    },
                  },
                }}
                onEditorStateChange={this.onEditorStateChange}
                toolbarCustomButtons={[<CustomOption />]}
              />

              <Link className={`btn-action btn-save ${this.state.buttonLoading == true && 'btn-loading'}`} onClick={this.createCategory.bind(this)}>
                <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>

            </section>
          </div>
        </div>
      </MasterLayout>
    );
  }

}
HuongDanSuDung.defaultProps = {
  validators: {}
}

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(HuongDanSuDung);



// WEBPACK FOOTER //
// ./src/components/modules/category/HuongDanSuDung.jsx